<div class="telr-status-dialog">
  <div class="telr-status-dialog__icon"
       [ngClass]="'telr-status-dialog__icon--' + data.iconVariant">
    <mat-icon [svgIcon]="data.svgIcon"></mat-icon>
  </div>
  <h2 class="telr-status-dialog__title">{{ data.title | translate }}</h2>
  <p class="telr-status-dialog__message">{{ data.message | translate }}</p>
  @if (data.note) {
    <div class="telr-status-dialog__note">
      <mat-icon svgIcon="warning-outline"></mat-icon>
      <span>{{ data.note | translate }}</span>
    </div>
  }
  <div class="telr-status-dialog__actions">
    <xa-button type="radius"
               (click)="close()"
               (keypress)="close()">{{ 'ok' | translate | uppercase }}</xa-button>
  </div>
</div>
